import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { WORKSPACES, DEFAULT_WORKSPACE } from "@/data/workspaces";
import log from "@/lib/log";

const WorkspaceContext = createContext(null);
// Workspace ID is a non-sensitive UI preference (atlas | northwind) — localStorage is appropriate.
// No PII, secrets, or auth tokens stored here.
const STORAGE_KEY = "aieco.workspace";

export function WorkspaceProvider({ children }) {
  const [workspaceId, setWorkspaceId] = useState(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (v && WORKSPACES[v]) return v;
    } catch (e) {
      log.warn("[workspace] localStorage read failed:", e?.message || e);
    }
    return DEFAULT_WORKSPACE;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, workspaceId);
    } catch (e) {
      log.warn("[workspace] localStorage write failed:", e?.message || e);
    }
  }, [workspaceId]);

  const value = useMemo(
    () => ({
      workspaceId,
      setWorkspaceId,
      data: WORKSPACES[workspaceId],
    }),
    [workspaceId]
  );
  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export function useWorkspace() {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) throw new Error("useWorkspace must be used inside WorkspaceProvider");
  return ctx;
}
